<template>
  <v-container>
    <div class="page-title">{{ $route.name }}</div>
    <v-row justify="space-between" class="mr-2">
      <v-col cols="12" md="3" sm="12">
        <c-card title="미수금" outlined>
          <template #headItems>
            <c-btn class="red--text display-1" text @click="flag = !flag">{{
              receiptNum
            }}</c-btn>
          </template>
        </c-card>
      </v-col>
      <v-col md="3"></v-col>
      <v-col cols="12" md="6" sm="12">
        <v-row justify="end">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-text-field
                  v-model="startDate"
                  label="시작일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="startDate"
              @input="startMenu = false"
              firstDayOfWeek="1"
              :selectedDate="startDate"
              locale="ko-kr"
            ></c-date-picker>
          </v-menu>
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div class="ml-5" style="width: 200px">
                <v-text-field
                  v-model="endDate"
                  label="종료일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="endDate"
              @input="endMenu = false"
              firstDayOfWeek="1"
              :selectedDate="endDate"
              locale="ko-kr"
            ></c-date-picker>
          </v-menu>
        </v-row>
        <v-row justify="end">
          <div class="ml-5" style="width: 200px">
            <v-select
              v-model="searchType"
              :items="searchTypeList"
              label="검색타입"
              placeholder="신청 회원, 담당자"
              item-text="label"
              item-value="value"
            ></v-select>
          </div>

          <div class="ml-5" style="width: 200px">
            <v-text-field
              v-model="searchKeyword"
              label="검색어"
              :placeholder="keywordPlaceholder"
              prepend-icon="search"
              maxlength="32"
              @keyup="onSearch"
            />
          </div>
        </v-row>
      </v-col>
    </v-row>
    <c-table
      :headers="cancelTableHeaders"
      itemKey="reservationId"
      :items="cancelList"
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #startTime="{ item }">
        {{ $func.dateTimeToString(item.startDateTime) }}
      </template>
      <template #created="{ item }">
        {{ $func.dateTimeToString(item.canceledDate) }}
      </template>
      <template #point="{ item }">
        <v-icon x-small color="light2Grey">place</v-icon>
        {{ item.departure }}
        <br />
        <v-icon x-small color="blue">place</v-icon>
        {{ item.destination }}
      </template>
      <template #plateNo="{ item }">
        {{ item.plateNo ? item.plateNo : "-" }}
      </template>
      <template #driverName="{ item }">
        {{ item.driverName ? item.driverName : "-" }}
      </template>
      <template #state="{ item }">
        <span
          :class="setColor(item.state.configName)"
          class="font-weight-bold"
          >{{ item.state.configName }}</span
        >
      </template>
      <template #detail="{ item }">
        <c-btn
          icon
          iconName="search"
          @click="onReservationDetail(item.reservationId)"
        />
      </template>
      <template #payment="{ item }">
        <span :class="setColor(item.payment)" class="font-weight-bold">{{
          onFormatPayment(item)
        }}</span>
      </template>
    </c-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      searchType: "CR_CUSTOMER_NAME",
      searchKeyword: "",
      startDate: this.$func.curDateStringAddDays(-7),
      endDate: this.$func.curDateString(),
      startMenu: false,
      endMenu: false,
      flag: false,
      receiptNum: 0,
      paymentColor: "",
      // reservationFlag: false,

      cancelTableHeaders: [
        {
          text: "예약자",
          value: "customerName",
          align: "left",
          sortable: true,
        },
        {
          text: "출발 시간",
          value: "startDateTime",
          align: "center",
          sortable: true,
        },
        {
          text: "취소일",
          value: "canceledDate",
          align: "center",
          sortable: true,
        },
        {
          text: "출발지 / 도착지",
          value: "point",
          align: "left",
          sortable: false,
        },
        {
          text: "담당 차량",
          value: "plateNo",
          align: "center",
          sortable: true,
        },
        {
          text: "담당 기사",
          value: "driverName",
          align: "center",
          sortable: true,
        },
        {
          text: "진행 상황",
          value: "state",
          align: "center",
          sortable: true,
        },
        {
          text: "수금 여부",
          value: "payment",
          align: "center",
          sortable: true,
        },
        {
          text: "상세보기",
          value: "detail",
          align: "center",
          sortable: false,
        },
      ],
      cancelList: [],
      manualDialogOpen: false,
      autoDialogOpen: false,
      reservationInfo: [],
      searchTypeList: [
        {
          label: "고객명",
          value: "CR_CUSTOMER_NAME",
        },
        {
          label: "기사이름",
          value: "DRIVER_NAME",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        sort: "",
      },
      totalElements: 0,
    };
  },
  watch: {
    startDate: function() {
      this.reqCanceledReservationList();
    },
    endDate: function() {
      this.reqCanceledReservationList();
    },
  },
  computed: {
    keywordPlaceholder() {
      return this.searchType === "CR_CUSTOMER_NAME" ? "고객명" : "기사이름";
    },
  },
  activated() {
    this.reqCanceledReservationList();
  },
  methods: {
    async reqCanceledReservationList() {
      try {
        const params = {
          ...this.pagination,
          searchType: this.searchType,
          searchKeyword: this.searchKeyword,
          filteringType: this.filteringType,
        };

        const res = await this.$api.getCanceledReservationPeriod(
          this.startDate,
          this.endDate,
          params
        );
        this.cancelList = res.data.content;
        this.totalElements = res.data.totalElements;
      } catch (err) {
        this.$store.commit("snackbar", {
          err,
          where: "reqCanceledReservationList",
        });
      }
    },
    setColor(data) {
      if (data === "무단취소" || data === "N") {
        return "red--text";
      } else {
        return "grey--text";
      }
    },
    onReservationDetail(data) {
      this.$router.push(`/canceledReservation/${data}`);
    },
    onFormatPayment(data) {
      return !!!data.payment ? "-" : data.payment === "Y" ? "수금" : "미수금";
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqCanceledReservationList();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqCanceledReservationList();
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped></style>
